import { useState, useCallback } from 'react';

var b=(o=!1)=>{let[e,t]=useState(o),a=useCallback(()=>t(s=>!s),[]);return [e,a]};

export { b as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4DQLIIK3.mjs.map